import React from 'react'
import { Menu, MenuDivider, MenuItem } from '@blueprintjs/core'
import { TaskT, TaskActionTypeT } from 'ui-io/task-io/task-t'
// import { useSessionState } from '@maps-internal/neutron-react-client'
import useSession from 'ui-io/use-session'
import { useMutation } from 'react-query'
import { taskRepublishMutation } from 'ui-io/queries/tasks/task-republish-mutation'

import { ContextMenuModelT } from './task-extra-actions'
import toasts from '../../utils/toasts'

const TaskPageContextMenu = ({
  task,
  setTaskAction,
  openModel,
}: {
  task: TaskT
  setTaskAction: (actionType: TaskActionTypeT) => void

  openModel: (model: ContextMenuModelT) => void
}) => {
  const { session } = useSession()
  const username = session?.username ?? ""
  const { isInProgress, assignee } = task
  const invisibileBlockStates = ['BLOCKED', 'ESCALATED', '_UNASSIGNED_']
  const mutation = useMutation(taskRepublishMutation, {
    onSuccess: async () => {
      toasts.success('Successfully republished the task')
    },
    onError: (error) => {
      toasts.error(`Error: ${error}`)
    },
  })

  return (
    <Menu>
      <MenuDivider title="Actions" />
      {task.currentState && !invisibileBlockStates.includes(task.currentState) && (
        <MenuItem
          text="Block"
          icon="disable"
          disabled={task.assignee !== username}
          onClick={() => {
            openModel('BLOCK')
          }}
        />
      )}
      {task.currentState === 'BLOCKED' && (
        <MenuItem
          text="Unblock"
          icon="unlock"
          onClick={() => {
            openModel('UNBLOCK')
          }}
        />
      )}
      {!task.isBlocked && (
        <>
          <MenuItem
            text={
              !task.isFastlaneTask ? 'Add to Fastlane' : 'Remove from Fastlane'
            }
            icon={!task.isFastlaneTask ? 'rocket-slant' : 'fast-backward'}
            onClick={() => {
              openModel('FASTLANE_TASK')
            }}
          />
        </>
      )}
      {/* {(isInProgress || !assignee) && (
        <MenuItem
          text={task.isL2Task ? 'De-escalate' : 'Escalate'}
          icon="flag"
          disabled={task.assignee !== username}
          onClick={() => {
            openModel('ESCALATE')
          }}
        />
      )} */}
      {!!assignee && (
        <MenuItem
          text="Close Task"
          icon="delete"
          onClick={() => {
            openModel('CLOSE')
          }}
        />
      )}
      {/* {task.isReadyForPublish && (
        <MenuItem
          text="Reject to Edit"
          icon="ban-circle"
          onClick={() => {
            openModel('REJECT_TO_EDIT')
          }}
        />
      )} */}
      {task.currentState === 'IN_PUBLISH' && (
        <>
          <MenuItem
            text="Re Publish"
            icon="redo"
            onClick={() => {
              mutation.mutate({
                taskId: task.id,
              })
            }}
          />
        </>
      )}

      {/* Action items related to task assignment */}
      {task.isReassignable ||
      task.isSelfAssignable ||
      task.assignee === username ? (
        <>
          <MenuDivider title="Assignment" />
          {task.isReassignable && (
            <MenuItem
              text="Reassign"
              icon="following"
              onClick={() => {
                setTaskAction('REASSIGN')
              }}
            />
          )}
          {!!task.assignee && task.assignee === username && (
            <MenuItem
              text="Unassign"
              icon="undo"
              onClick={() => {
                setTaskAction('UNASSIGN')
              }}
            />
          )}
          {task.isSelfAssignable && (
            <MenuItem
              text="Self assign"
              icon="following"
              onClick={() => {
                setTaskAction('SELF_ASSIGN')
              }}
            />
          )}
        </>
      ) : undefined}

      {/* Action items related to Task editing */}
      <>
        <MenuDivider title="Editing" />
        <MenuItem
          text="Edit Task"
          icon="edit"
          onClick={() => {
            setTaskAction('EDIT')
          }}
        />
      </>

      <>
        <MenuDivider />
        <MenuItem
          text="File an Issue"
          icon={"saved"}
          href={""}
        />
      </>
    </Menu>
  )
}

export default TaskPageContextMenu
